"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CashierPaymentsMethod_1 = require("./CashierPaymentsMethod");
exports.default = CashierPaymentsMethod_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/CashierPaymentsMethod/index.js
// module id = 148
// module chunks = 0 1